module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZBAMAAAA2x5hQAAAAElBMVEUAAAD///////////////////8+Uq06AAAABXRSTlMAYeZzn4g8niUAAABlSURBVBjTZdCxDYAwDETRi2AAmvQgRE/DCAyAxO2/CpL1KU5J48RPSWxr2sRqu3R54dR96vAD2au6wdo0FxJBAklIlYVACLyLfoTAItZsvxot7+Wb+V/WknVmD9lf9p5zyZnlPD/OICW7tlTpOAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base/video_close_white.png
// module id = 2Ab1
// module chunks = 0